// Token storage is isolated in this module so we can swap it out later
// (e.g. to httpOnly cookies) without touching the rest of the app.
//
// SECURITY NOTE: localStorage is vulnerable to XSS. Mitigations:
// - React auto-escapes rendered strings (no dangerouslySetInnerHTML in this app)
// - CSP header is set by the backend (app/security/headers.py)
// - Dependencies are audited via npm audit / Dependabot
// A future improvement is to move tokens to httpOnly cookies and require
// a CSRF token, but that needs backend changes.

const ACCESS_KEY = "chimera_access_token";
const REFRESH_KEY = "chimera_refresh_token";

// During static pre-rendering (vite-react-ssg) this module is evaluated
// in Node, where `localStorage` doesn't exist. The auth store reads a
// token at module-init time, so every accessor must no-op on the server.
const hasStorage = typeof localStorage !== "undefined";

export function getAccessToken(): string | null {
  return hasStorage ? localStorage.getItem(ACCESS_KEY) : null;
}

export function getRefreshToken(): string | null {
  return hasStorage ? localStorage.getItem(REFRESH_KEY) : null;
}

export function setTokens(accessToken: string, refreshToken?: string): void {
  if (!hasStorage) return;
  localStorage.setItem(ACCESS_KEY, accessToken);
  if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
}

export function clearTokens(): void {
  if (!hasStorage) return;
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}
